import { zSchema, schemes } from "@zeal/common";

export const deleteDepositRuleRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  ruleID: schemes.uuid(),
});

export type TDeleteDepositRuleRequestSchema = zSchema.infer<
  typeof deleteDepositRuleRequestSchema
>;

export const deleteDepositRuleResponseSchema = zSchema.object({
  success: zSchema.boolean(),
});

export type TDeleteDepositRuleResponseSchema = zSchema.infer<
  typeof deleteDepositRuleResponseSchema
>;
